<template>
    <div class="container d-flex py-5 main-container">
        <div class="my-auto w-100 main-area">
            <div class="registration-head text-center d-flex align-items-end">
                <img
                    src="@/assets/images/wtiogomark_ra.png"
                    alt="bloom"
                    style="width: 15%;"
                />
                <h1>Bloomキャリア登録　法人利用規約　|　株式会社Bloom</h1>
            </div>
            <!-- ends-registration-head -->
            <div class="registration-detail-area" style="text-align: justify;">
                <p>「Bloom キャリア登録」法人利用規約</p>
                <p>
                    株式会社Bloom（以下「当社」といいます。）が提供するタレントプール活用型採用サービス「Bloom キャリア登録（以下「本サービス」といいます。）」に関するサービスの利用にあたっては、下記の利用規約（以下「本規約」といいます。）について承諾の上で申込むものとします。
                </p>

                <h2 class="rd-title">第１条（適用）</h2>
                <p>
                    1. 本規約は、本サービスの提供条件及び本サービスの利用に関する当社と事業者との間の権利義務関係を定めることを目的とし、事業者と当社との間の本サービスの利用に関わる一切の関係に適用されます。
                </p>
                <p>
                    2. 事業者から本サービスの利用に関する当社所定の申込書が提出され、同申込を当社が承諾した場合の当該申込書の定め等、別途事業者と当社の間において書面または電子メールによって合意した内容がある場合、その内容は本規約の定めに優先して適用されることとします。
                </p>
                <h2 class="rd-title">第２条（定義）</h2>
                <p>
                    本規約において使用される各用語の定義は、以下に定めるとおりとします。
                </p>
                <p>① 事業者</p>
                <p>
                    本サービスの利用を申込み、当社がこれを承諾した法人をいいます。
                </p>
                <p>② ユーザー</p>
                <p>
                    本サービスを利用している個人をいいます。
                </p>
                <h2 class="rd-title">第３条（サービスの提供）</h2>
                <p>
                    1. 当社は、本サービスにおいて、以下のサービスを事業者に提供するものとします。
                </p>
                <p>① 事業者の採用活動に関心を持つユーザーの情報登録・情報閲覧、事業者による情報保管、及びユーザーへの情報提供・コミュニケーション</p>
                <p>② （事業者が当社所定の形式に則り利用を希望し、当社が利用を承諾した場合の）ユーザーへの連絡代行・事業者の管理システムへの情報登録など、本サービス運用における当社での活用支援業務（以下「活用支援パートナーサービス」という）</p>
                <p>③ 当社が必要と判断した上記に付随するその他のサービス</p>
                <p>
                    2. 事業者は、本サービスの利用において、以下を承諾するものとします。
                </p>
                <p>① 事業者の採用に関心を持つユーザーが情報登録後、本サービスを利用している他の事業者からの情報提供を本サービスにおいて促すこと</p>
                <p>② ユーザーが本サービスを退会、または事業者への情報登録を停止した場合、事業者側の管理画面からユーザーの登録情報閲覧が行えなくなること。また、本サービスへの最終ログインから1年経過したユーザーは退会となること</p>
                <p>③ ユーザーが登録する職務経歴・連絡先などの情報は当社に帰属し、事業者がサービス利用を停止した際も当社はユーザーの情報を継続して保有すること</p>
                <p>④ 本サービスを利用してユーザーに連絡を行い、それを起点に選考応募に至り採用内定承諾・入社決定となった場合には、ユーザー情報登録からの経過日数を問わず、事業者は速やかに当社にその旨を通知すること（以下この通知に係るユーザーを「入社決定者」という）。なお、ユーザーが事業者に情報登録をしていた場合であっても転職エージェントや事業者の社員経由など他のユーザープロフィール情報や連絡手段をもとに求人情報提供がなされ、選考応募・入社となった場合には本サービスを利用した採用とみなされず、当社への通知も不要であること</p>
                <p>⑤ 事業者が本条１項②の活用支援パートナーサービスを利用する場合、対応する業務範囲や業務内容は個別の業務設計を行う必要があること。また本サービスにおいて事業者の事務業務を代行する場合は事業者からの業務委託となり、当社がユーザーに連絡する際は事業者の所属としての名義で連絡を行う場合があること</p>
                <p>⑥ 本サービスの契約期間中、当社から事業者に対して利用目的を説明した上で、事業者の採用ホームページなど事業者が広く一般に公開している求人情報をユーザー向けに表示すること。なお、表示順や表示情報などは当社のアルゴリズムやサービス方針に基づく場合があること</p>
                <p>⑦ 本サービスの契約期間中、当社から事業者に対して利用目的を説明した上で、本サービスに関するウェブサイトやオンラインイベント等において事業者から提供を受けた求人情報、会社説明資料等を掲載すること</p>
                <p>⑧ 本サービスの契約期間中、事業者以外の第三者に対し、事業者が本サービスを利用している事実を開示すること</p>
                <p>
                    3. 当社は、本サービスの全部または一部を第三者に委託できるものとし、事業者は、かかる委託を承諾するものとします。
                </p>
                <h2 class="rd-title">第４条（本サービスの利用料金・支払いと契約）</h2>
                <p>
                    1. 事業者は、当社の定める支払期日までに当社の定める決済方法にて利用料金を支払うものとします。
                </p>
                <p>
                    2. 利用料金については別途当社指定の「申込書」に定めます。本サービスを通じた入社決定者の特定については第3条2項④に定める事業者からの通知に基づくものとし、事業者は対象ユーザーの名前・提示年収額・入社予定日についても当社へ速やかに通知するものとします。なお、対象ユーザーのサービス登録の経緯によって費用が変動する申込内容の場合、登録経緯については入社決定者発生の都度当社から事業者へ通知するものとします。
                </p>
                <p>
                    3. 本サービスを事業者が適切に利用し、結果としてユーザーの同意のもと事業者の子会社・関連会社など事業者以外での採用・入社が決まった場合、当該法人でも事業者同様に本サービスへの申込みを行うものとします。利用料金・支払い方法については、「申込書」に定めます。
                </p>
                <p>
                    4. 利用料金全額が前項の支払期日までに支払われない場合には、当社は当該事業者への本サービス提供の停止をすることができます。
                </p>
                <p>
                    5. 本サービスの契約期間は１年間とし、事業者が本契約の解約を申し出るときは、契約期間満了1ヶ月前までに当社所定の方法に従い、解約の意思と解約日を申告するものとします。契約期間満了1ヶ月前までに申し出が無い場合、契約期間満了日の翌日より１年間、契約が自動更新されることとします。
                </p>
                <h2 class="rd-title">第５条（本サービスの変更・中断・終了）</h2>
                <p>
                    1. 当社は、次の各号のいずれかに該当する場合は、事業者に何ら通知することなく本サービスの全部もしくは一部を変更し、または一時中断することがあります。また、一定期間の通知の上で、本サービスの全部または一部を終了することがあります。
                </p>
                <p>① 本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合</p>
                <p>② コンピューター、通信回線等が事故により停止した場合</p>
                <p>③ 地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</p>
                <p>④ その他、当社が停止または中断が事業運営上やむを得ないと判断した場合</p>
                <p>
                    2. 当社は、本条に基づき当社が行った措置によって事業者に生じた損害について一切責任を負いません。
                </p>
                <h2 class="rd-title">第６条（本サービス提供の終了事由）</h2>
                <p>
                    1. 事業者は、本サービスの提供を終了する場合には、当社が指定する方法にて終了（本サービス利用契約の解約）の申出を行うものとします。この場合の解約時期や方法については、4条5項の定めに従うものとします。
                </p>
                <p>
                    2. 当社は、次の各号のいずれかに該当する場合、当該事業者に対して何らの催告を要することなく、本サービスの提供を終了（本サービス利用契約を解約）することができるものとします。
                </p>
                <p>① 本規約のいずれかの条項に違反した場合</p>
                <p>② 事業者による申込情報又は登録情報に虚偽の事実があることが判明した場合</p>
                <p>③ １年以上本サービスの利用がない場合</p>
                <p>④ 当社からの問い合わせその他の回答を求める連絡に対して、１カ月以上応答がない場合</p>
                <p>⑤ その他、本サービスを利用する事業者として当社が適当でないと判断した場合</p>
                <p>
                    3. 当社は、前1項、前2項に基づき本サービスの提供を終了した場合、終了日をもって事業者の管理画面へのログインを不可とし、ログインに必要なアカウント情報や管理画面内の求人情報などを速やかに削除するものとします。なお、第３条第2項第③号に定める通り、当社はユーザーの情報を継続して保有するものとします。
                </p>
                <h2 class="rd-title">第７条（事業者の秘密保持義務）</h2>
                <p>
                    1. 事業者は、当社ないしはユーザーが事業者に提供した一切の個人情報（個人情報保護法の定義に従うものとし、以下あわせて「ユーザー情報」といいます。）を、当該事業者の採用活動の遂行目的にのみ使用するものとし、その他の目的（商業目的であると否とを問わない。）に一切使用しないものとします。
                </p>
                <p>
                    2. 事業者は、ユーザー情報を機密として厳重かつ適正に取り扱うものとし、第三者に開示または漏洩しないものとします。
                </p>
                <p>
                    3. 事業者によるユーザー情報の使用および管理に関し、事業者その他の第三者から当社に対して訴訟提起その他のクレームがなされた場合、かかるクレームや訴訟に対して、事業者は一切の責任と費用でこれを解決するものとし、当社が一切の責任を負わないことに同意するものとします。
                </p>
                <p>
                    4. 事業者は、本サービスの利用を通じて知りうる当社の一般に公開していない情報（本サービスに関する情報・しくみ・ノウハウ・プログラムソース等を含む）の一切を第三者へ開示・漏洩もしくは事業者自らのために利用してはならないものとします。
                </p>
                <p>
                    5. 事業者は、本サービスの操作を第三者に委託する場合も本条項と同等の義務を当該第三者に負わせるものとします。ただし、それにより事業者の責を免れるものではありません。
                </p>
                <h2 class="rd-title">第８条（IDおよびパスワード管理）</h2>
                <p>
                    1. 事業者は、当社が本サービスに関連してIDまたはパスワード（以下「ID等」といいます。）を発行した場合は、当該ID等を自らの責任において使用・管理し、いかなる場合も当該ID等を第三者に使用させ、または譲渡してはならないものとします。
                </p>
                <p>
                    2. 当社または事業者の都合によりID等を再発行する場合には、当社は、情報セキュリティの観点から事業者にかかる認証を行うことができるものとします。なお、事業者は、ID等の再発行にかかる事務処理は一定の時間を要し、当社が即時の再発行に応じられないことがあることを予め承諾するものとします。
                </p>
                <h2 class="rd-title">第９条（当社による利用履歴の利用、個人情報の取扱い）</h2>
                <p>
                    1. 当社は、別途定めるプライバシーポリシーに従い、ユーザーの個人情報を適切に取得・利用・提供・管理します。なお、当社は、個人を特定できない形式による統計データ等を作成し、当該統計データ等につき何らの制限なく利用することができるものとします。
                </p>
                <p>
                    2. 当社は、事業者の採用ホームページなど事業者が広く一般に公開している求人情報について、本サービスの適切な運用及びユーザーへの最適な情報提供を目的として、当社が定める方法により分析、及びユーザーへの表示に利用できるものとします。
                </p>
                <p>
                    3. 当社は、個人情報を当社管理のサーバー上にて適正に管理、取り扱うものとします。なお、当社管理のサーバーから削除された情報を復旧することはできません。
                </p>
                <p>
                    4. 当社は、業務上必要な範囲内でのみ第三者に個人情報を取り扱う業務の全部または一部を委託することができるものとします（以下、かかる第三者を「委託先」といいます。）。但し、その場合、当社は、本条における当社の義務と同等の義務を委託
                </p>
                <p>
                    先にも負わせるものとします。
                </p>
                <h2 class="rd-title">第１０条（禁止事項）</h2>
                <p>
                    事業者は、以下の行為をしてはならないものとします。
                </p>
                <p>① 虚偽または不正確な情報を当社またはユーザーに対し提供する行為</p>
                <p>② 採用以外の目的でユーザーと直接連絡を取る行為</p>
                <p>③ 当社に支払うべき利用料を不当に支払わない行為</p>
                <p>④ 当社、他の事業者またはユーザーの業務・営業を妨害する行為、または社会的信用もしくは評価を毀損する行為</p>
                <p>⑤ 他の事業者、ユーザー、当社または当社の従業員その他当社の事業に関わる一切の関係者（以下「関係者」といいます。）を誹謗、中傷もしくは侮辱する行為</p>
                <p>⑥ 当社または関係者が有する著作権、商標権その他の知的財産権を含む一切の財産的権利、営業上の秘密、名誉、プライバシーなどを侵害する行為</p>
                <p>⑦ 法令または公序良俗に違反する行為</p>
                <p>⑧ 前各号に該当するおそれのある行為</p>
                <h2 class="rd-title">第１１条（反社会的勢力等の排除）</h2>
                <p>
                    1. 事業者は、現在および将来において、次の各号に掲げる事項を表明し保証するものとします。
                </p>
                <p>① 事業者が暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係者、総会屋その他の反社会的勢力（以下、総称して「反社会的勢力」という。）に該当しないこと</p>
                <p>② 事業者が、反社会的勢力に対して資金等を提供し、または便宜を供与し、もしくは便宜の供与を受ける等の関係を有していないこと</p>
                <p>③ 前各号のほか、事業者が、反社会的勢力と関係を有することによって、社会的に非難されることがないこと</p>
                <p>
                    2. 当社は、事業者が前項各号のいずれかに該当することが明らかになった場合には、通知をすることなく登録を解約することができるものとします。ただし、当社は、本項に基づく解約により事業者に生じた損害について賠償する責任を負わないものとし、当社に損害が生じた場合には事業者は損害を賠償しなければならないものとします。
                </p>
                <h2 class="rd-title">第１２条（情報の権利帰属）</h2>
                <p>
                    1. 本サービスに関するウェブサイトのコンテンツ（当社が事業者の従業員にインタビューして作成した記事等、事業者から情報提供等を受けた上で当社が制作したコンテンツを含みます。）を含む本サービスにて事業者に提供される情報に関する著作権その他一切の財産的権利は、当社に帰属します。
                </p>
                <p>
                    2. 前項の定めにかかわらず、本サービスに関連して当社が事業者から提供を受けた求人情報、会社説明資料等の著作権は、当該事業者に帰属します。
                </p>
                <p>
                    3. 事業者は、第1項に定める当社の著作物につき、当社による明示的な許諾があった場合、事業者のウェブサイトへの掲載等の利用行為をすることができます。
                </p>
                <h2 class="rd-title">第１３条 （権利義務の譲渡禁止）</h2>
                <p>
                    当社は、当社の事前承認無しに事業者が本規約に基づく権利義務又は契約上の地位を第三者に譲渡または承継することを禁止します。
                </p>
                <h2 class="rd-title">第１４条（不保証）</h2>
                <p>
                    1. 本サービスにおいてユーザーから提供される情報は当該情報を提供する者の責任で提供されるものであり、事業者は、提供情報の真実性、合法性、安全性、適切性、有用性について当社が何ら保証しないことを了承のうえ、自己の責任において利用するものとします。
                </p>
                <p>
                    2. 当社は以下の各号のいずれについても保証するものではないことを了承のうえ、自己の責任において利用するものとします。
                </p>
                <p>① 本サービスの提供に不具合やエラーや障害が生じないこと</p>
                <p>② 本サービスから得られる情報等が正確なものであること</p>
                <p>③ 本サービスの機能が事業者の期待を満たすものであること</p>
                <p>④ ユーザーの採用の確実性や事業者に応募するユーザーの資質・能力および事業者への適合性が事業者の期待を満たすものであること</p>
                <p>⑤ 本サービスの利用において不適切な内容が含まれないこと</p>
                <h2 class="rd-title">第１５条（当社の免責）</h2>
                <p>
                    1. 事業者は、自己の責任により本サービスを利用するものとし、当社は、本規約もしくはその履行および本サービスの利用に関して事業者につき生じた損害（精神的苦痛、その他の金銭的損失を含む一切の不利益をいう。）について、当社の故意または重大な過失による損害であることが明白な場合を除き、何らの賠償義務を負わないものとします。なお、当社が責任を負う場合であっても、かかる責任は、直接かつ通常の損害の範囲に限られ、かつ事業者が本契約に基づき支払済みの対価相当額（1年分）を上限とします。
                </p>
                <p>
                    2. 当社は、個人情報の帰属主体（以下「本人」といいます。）に損害を与えた場合には、本人に対する責任を負うものとし、事業者が本人からの請求に応じて損害賠償をした場合、当社に責任が認められる範囲でその賠償金相当額を事業者に対して支払うものとします。但し、事業者が本人から損害賠償の請求を受けた後直ちに当社に対してその旨通知し、当社に対して紛争解決にあたる機会を与えなかった場合はこの限りではありません。
                </p>
                <p>
                    3. 天変地異、ネットワーク上の障害、通常講ずるべきウィルス対策では防止できないウィルス被害その他当社の責によらない事由によって本サービスの提供が遅延し、または困難もしくは不能となった場合、これによって事業者に発生した一切の損害について、当社は責任を負わないものとします。
                </p>
                <p>
                    4. 当社は、取り扱い業務において通常要求される程度の合理的な措置を当社が講じていたにもかかわらず、事業者または第三者の責めに帰すべき事由により生じた損失（①ウィルスによるサーバーダウン、システム障害、データの流出・損壊および誤った情報の掲載、②ハッキングによるサーバーダウン、システム障害、データの流出・損壊および誤った情報の掲載、③プロバイダのダウン、④事業者の操作ミスによるデータの流出・損壊、採用機会の損失および誤った情報の掲載並びに⑤システム環境の変化による障害、本システムの瑕疵などを含みます。）につき、何らの責任も負わないものとします。
                </p>
                <p>
                    5. 事業者は、事業者のコンピューター端末、オペレーティングシステム環境および利用ブラウザ等によって本サービスの一部または全部を利用できない場合があることをあらかじめ了承するものとします。
                </p>
                <p>
                    6. 事業者は、ユーザーまたは第三者と労働条件等本サービスの利用について紛争（事業者が直接本人に連絡する際に生じたいかなる紛争・トラブルが含まれますが、これに限られません。）が生じた場合には自己の責任と負担で当該紛争を直接解決するものとし、当該紛争について当社は免責され、一切関与しないものとします。
                </p>
                <p>
                    7. 本サービスにてユーザーに提示する求人情報、会社説明資料等は事業者から提供を受けたもの、あるいは事業者の採用ホームページなど事業者が広く一般に公開しているものです。事業者はこれを踏まえ、求人情報、会社説明資料等の正確性・最新性の確保に努め、他方で、同確保を怠ったことにより、事業者とユーザーの間で紛争・トラブルが生じたとしても、当社は何らの責任も負わないものとします。
                </p>
                <h2 class="rd-title">第１６条（損害賠償責任）</h2>
                <p>
                    事業者が本規約の各事項に違反して、当社、関係者または第三者に損害を与えた場合は、事業者はその損害を賠償するものとします。
                </p>
                <h2 class="rd-title">第１７条（本規約の変更）</h2>
                <p>
                    当社は、必要に応じて本規約の内容を変更することができるものとします。変更後の本規約の内容は、本サービスにおいて掲載するものとし、掲載後1カ月経過後に本サービスを継続して利用している事業者は、変更後の本規約の内容に同意したものとみなします。
                </p>
                <h2 class="rd-title">第１８条（本サービス利用契約上の地位の譲渡）</h2>
                <p>
                    当社は本サービスにかかる事業を他者に譲渡した場合には、当該事業譲渡に伴いサービス利用契約上の地位、本規約に基づく権利及び義務並びに事業者の申込情報及び登録事項を当該事業譲渡の譲受人に譲渡することができるものとし、事業者は、かかる譲渡について予め同意したものとします。なお、本条に定める事業譲渡には、会社分割その他事業が移転するあらゆる場合を含むものとします。
                </p>
                <h2 class="rd-title">第１９条（定めのない事項）</h2>
                <p>
                    本規約に定めのない事項は、日本の法令の定めに従い、事業者と当社との間において、互いに誠意をもって協議し解決することとします。
                </p>
                <h2 class="rd-title">第２０条（管轄裁判所）</h2>
                <p>
                    本規約の各事項に関連して紛争が生じた場合は、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
                </p>
                <h2 class="rd-title">附則</h2>
                <p>2018年7月24日 制定・施行</p>
                <p>2019年6月25日 改訂</p>
                <p>2020年2月27日 改訂</p>
                <p>2021年6月8日 改訂</p>
                <p>2024年5月30日 改訂</p>
                <p>2025年10月8日 改訂</p>
            </div>
            <!--ends registration-detail-area -->
        </div>
        <!-- ends main-area -->
    </div>
</template>

<script>
/* eslint-disable */

export default {
    name: "Agreement",
    mounted() {
        this.changeBodyToWhite();
    },
};
</script>

<style scoped>
.main-area {
    color: #333333 !important;
    box-shadow: none !important;
    background: #fff !important;
}
</style>
